import { useRef, useEffect } from 'react';
/**
 * This hook gives the value of any variable from the previous render invocation
 */
export var usePrevious = function (value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
};
//# sourceMappingURL=index.js.map